import React from "react";
import firebase from 'firebase'
import fire from '../firebase/firebase'
import StyledFirebaseAuth from 'react-firebaseui/StyledFirebaseAuth'
import Container from 'react-bootstrap/Container'
import { Card } from "react-bootstrap";

function Login(props) {

  const uiConfig = {
    signInSuccessUrl: '/',
    signInFlow: 'popup',
    signInOptions: [
      firebase.auth.GoogleAuthProvider.PROVIDER_ID,
    ],
  };

  return (
    <div>
      <Container>
        <Card className="m-2 mt-4">
          <Card.Header as="h5">Login to Sequences</Card.Header>
          <Card.Body>
            <StyledFirebaseAuth uiConfig={uiConfig} firebaseAuth={fire.auth()} />
          </Card.Body>
        </Card>
      </Container>
    </div>
  );
}

export default Login
